import React from 'react';
import { Autocomplete, AutocompleteProps, AutocompleteRenderInputParams, CircularProgress, InputAdornment, TextField, TextFieldProps } from '@mui/material';

import { useCompaniesQuery } from '../hooks/useCompaniesQuery';


export type CompanyAutocompleteProps = Omit<AutocompleteProps<any, false, false, true>, 'isOptionEqualToValue' | 'getOptionLabel' | 'renderInput' | 'options' | 'onInputChange' | 'loading'> & {
  label: TextFieldProps['label'];
  TextFieldProps?: Omit<TextFieldProps, 'label'>;
  filters?: Omit<Companies.GetListParams, 'search'>;
};

export const CompanyAutocomplete: React.FC<CompanyAutocompleteProps> = ({ value, defaultValue, label, filters, TextFieldProps, ...props }) => {

  const [search, setSearch] = React.useState('');
  const { companies, isPending } = useCompaniesQuery({
    ...filters,
    search,
  });

  return (
    <Autocomplete
      {...props}
      value={value}
      defaultValue={defaultValue}
      isOptionEqualToValue={(option, value) => {
        if (typeof option === 'object' && option !== null && 'id' in option &&
            typeof value === 'object' && value !== null && 'id' in value) {
          return option.id === value.id;
        }
        return option === value;
      }}
      getOptionLabel={(option: string | Companies.Company) =>
        typeof option === 'string' ? option : option.name
      }
      renderInput={(props: AutocompleteRenderInputParams) =>
        <TextField
          {...props}
          {...TextFieldProps}
          label={label}
          InputProps={{
            ...props?.InputProps,
            ...TextFieldProps?.InputProps,
            endAdornment: isPending ? <InputAdornment position="end"><CircularProgress color="inherit" size={20}/></InputAdornment> : props?.InputProps?.endAdornment,
          }}
          InputLabelProps={{
            ...props?.InputLabelProps,
            ...TextFieldProps?.InputLabelProps,
          }}
        />
      }
      options={companies}
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') {
          setSearch(newValue);
        }
      }}
      filterOptions={(x) => x}
      loading={isPending}
    />
  );
};
